import * as accessibility from "accessibility/legacy/legacy";
export { accessibility };
export default accessibility;
